/* Welcome offer: Shopify owns discount eligibility and all monetary totals. */
(function () {
  'use strict';
  if (window.WynchWelcomeCartV1) return;
  var inflight;
  var syncing;
  var policyElement = document.getElementById('wynch-welcome-policy-v1');
  var policy = policyElement ? JSON.parse(policyElement.textContent) : null;
  if (!policy || typeof policy.loggedIn !== 'boolean' || typeof policy.hasOrders !== 'boolean') {
    throw new Error('WELCOME_CART_POLICY_MISSING');
  }
  var welcomeCode = 'WELCOME30';
  function path(suffix) { return (window.Shopify && window.Shopify.routes.root || '/') + suffix; }
  async function request(url, options) {
    var response = await fetch(url, options);
    if (!response.ok) throw new Error('WELCOME_CART_REQUEST_FAILED');
    return response.json();
  }
  async function renderCart(cart) {
      var html = cart.sections && cart.sections['section-ajax-cart'];
      if (!html) {
        var sections = await request(path('?sections=section-ajax-cart'), { credentials: 'same-origin', cache: 'no-store' });
        html = sections['section-ajax-cart'];
      }
      if (!html) throw new Error('WELCOME_CART_REFRESH_FAILED');
      var next = new DOMParser().parseFromString(html, 'text/html');
      var selectors = ['#products-cart #cart-body', '#products-cart footer'];
      var pairs = selectors.map(function (selector) { return [document.querySelector(selector), next.querySelector(selector)]; });
      if (pairs.some(function (pair) { return !pair[0] || !pair[1]; })) throw new Error('WELCOME_CART_REFRESH_FAILED');
      pairs.forEach(function (pair) { pair[0].replaceWith(pair[1]); });
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
  }
  async function claim(code) {
    if (policy.hasOrders) throw new Error('WELCOME_CART_GUEST_REQUIRED');
    if (syncing) await syncing;
    if (inflight) return inflight;
    inflight = (async function () {
      var current = await request(path('cart.js'), { credentials: 'same-origin', cache: 'no-store' });
      var codes = (current.discount_codes || []).map(function (entry) { return entry.code; });
      if (!codes.some(function (value) { return value.toUpperCase() === code.toUpperCase(); })) codes.push(code);
      var measurement = window.WynchWelcomeAnalyticsV1;
      var measurementToken = '';
      try { measurementToken = measurement ? measurement.token() : ''; } catch (_) {}
      var attributes = { wynch_welcome_voucher: code };
      if (measurementToken) attributes._wynch_welcome_measurement = measurementToken;
      var cart = await request(path('cart/update.js'), {
        method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ discount: codes.join(','), attributes: attributes,
          sections: ['section-ajax-cart'], sections_url: window.location.pathname })
      });
      // Record the authoritative saved voucher before presentation can fail.
      try { if (measurement) measurement.claimed(cart, measurementToken); } catch (_) {}
      await renderCart(cart);
      return cart;
    })();
    try { return await inflight; } finally { inflight = null; }
  }
  // Shopify checkout can remove a code without clearing our display-only attribute.
  // Re-read server state on return, including Safari/Chrome back-forward cache restores.
  async function reconcile() {
    if (inflight) return inflight;
    if (syncing) return syncing;
    if (!policy.hasOrders && !document.querySelector('[data-wynch-welcome-voucher]')) return;
    syncing = (async function () {
      var cart = await request(path('cart.js'), { credentials: 'same-origin', cache: 'no-store' });
      var code = cart.attributes && cart.attributes.wynch_welcome_voucher;
      // Existing customers may have claimed the offer before login. Remove only
      // WELCOME30, preserving unrelated codes and Shopify's monetary calculation.
      if (policy.hasOrders) {
        if (!Array.isArray(cart.discount_codes)) throw new Error('WELCOME_CART_CODES_MISSING');
        var remaining = cart.discount_codes.filter(function (entry) {
          return entry.code.toUpperCase() !== welcomeCode;
        });
        if (remaining.length !== cart.discount_codes.length || code) {
          cart = await request(path('cart/update.js'), {
            method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ discount: remaining.map(function (entry) { return entry.code; }).join(','),
              attributes: { wynch_welcome_voucher: '' },
              sections: ['section-ajax-cart'], sections_url: window.location.pathname })
          });
          await renderCart(cart);
          document.dispatchEvent(new CustomEvent('wynch:welcome-voucher-removed'));
        }
        return cart;
      }
      var removed = !code;
      if (code && Array.isArray(cart.discount_codes)) {
        removed = !cart.discount_codes.some(function (entry) {
          return entry.code.toUpperCase() === code.toUpperCase();
        });
        // applicable:false is still a saved voucher (e.g. an empty cart), not removal.
        if (removed) {
          cart = await request(path('cart/update.js'), {
            method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ attributes: { wynch_welcome_voucher: '' },
              sections: ['section-ajax-cart'], sections_url: window.location.pathname })
          });
        }
      }
      await renderCart(cart);
      if (removed) document.dispatchEvent(new CustomEvent('wynch:welcome-voucher-removed'));
      return cart;
    })();
    try { return await syncing; } finally { syncing = null; }
  }
  function onReturn() {
    reconcile().catch(function () {
      // Leave the last known state intact on network failure; focus/pageshow retries.
    });
  }
  window.addEventListener('pageshow', onReturn);
  window.addEventListener('focus', onReturn);
  function open() {
    var alpine = window.Alpine;
    try {
      if (alpine && typeof alpine.evaluate === 'function'
        && alpine.evaluate(document.body, "typeof openCart === 'function'") === true) {
        alpine.evaluate(document.body, 'openCart()');
        return;
      }
    } catch (_) {}
    var app = alpine && typeof alpine.$data === 'function' && alpine.$data(document.body);
    if (app && typeof app.openCart === 'function') { app.openCart(); return; }
    var trigger = document.getElementById('item_count');
    if (trigger) { trigger.click(); return; }
    window.location.assign(path('cart'));
  }
  function confetti() {
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (!Element.prototype.animate) return;
    var layer = document.createElement('div');
    layer.setAttribute('aria-hidden', 'true');
    layer.dataset.wynchWelcomeConfetti = '';
    layer.style.cssText = 'position:fixed;inset:0;z-index:10020;pointer-events:none;overflow:hidden';
    document.body.appendChild(layer);
    var colors = ['#ff6315', '#cbdaf0', '#f3c553', '#ffffff'];
    for (var i = 0; i < 58; i++) {
      var piece = document.createElement('i');
      var left = i % 2 === 0;
      var x = (left ? 1 : -1) * (90 + Math.random() * window.innerWidth * 0.42);
      var y = -(170 + Math.random() * window.innerHeight * 0.52);
      piece.style.cssText = 'position:absolute;bottom:22px;' + (left ? 'left:18px;' : 'right:18px;') + 'width:8px;height:12px;background:' + colors[i % colors.length];
      layer.appendChild(piece);
      piece.animate([
        { transform: 'translate(0,0) rotate(0deg)', opacity: 0 },
        { transform: 'translate(' + x + 'px,' + y + 'px) rotate(540deg)', opacity: 1, offset: 0.55 },
        { transform: 'translate(' + x * 1.15 + 'px,' + (y + 350) + 'px) rotate(900deg)', opacity: 0 }
      ], { duration: 2300 + Math.random() * 700, delay: Math.random() * 300, fill: 'forwards' });
    }
    setTimeout(function () { layer.remove(); }, 3400);
  }
  window.WynchWelcomeCartV1 = { claim: claim, reconcile: reconcile, open: open, confetti: confetti };
})();
